<template>
  <div>
    <div
      class="flex flex-row flex-wrap items-center gap-4 text-center justify-center my-4 px-3 md:px-0 md:max-w-screen-lg mx-auto text-4xl"
    >
      <Icon name="Privacy Primary" class="shrink-0 text-primary w-[1em] h-[1em]" />

      <h1>{{ $t("pages.account.order-history.title") }}</h1>
      <AccountEmailValidationAlert />
    </div>

    <div class="bg-[#F0FBFB]">
      <section class="py-7 w-full max-w-[1054px] mx-auto md:mt-15">
        <p class="font-semibold text-lg max-w-2xl px-4">
          {{ $t("pages.account.order-history.subtitle") }}
        </p>
        <div class="mt-8 mb-10">
          <Table
            :columns="[
              {
                key: 'date',
                label: $t('pages.account.order-history.table.date'),
              },
              {
                key: 'order_id',
                label: $t('pages.account.order-history.table.order_id'),
              },
              {
                key: 'amount',
                label: $t('pages.account.order-history.table.amount'),
              },
            ]"
            :data="data"
            :pagination="{
              page: 1,
              rowsPerPage: 5,
            }"
            class="mx-auto"
            head-cell-class="text-sm"
            table-class="border-y md:border shadow-none"
            pagination-class="px-4"
          />
        </div>

        <CommonLookingForTestResultCard class="m-4 md:hidden" />
      </section>
    </div>

    <div class="mt-16 hidden md:block px-4">
      <CommonLookingForTestResultCard
        class="border rounded-sm md:mx-auto md:h-[166px] md:px-20 max-w-[1029px]"
        variant="wide"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const data = [
  {
    date: "2024-10-28",
    order_id: "ORD123456",
    amount: "$150.00",
  },
  {
    date: "2024-10-27",
    order_id: "ORD123457",
    amount: "$200.00",
  },
  {
    date: "2024-10-26",
    order_id: "ORD123458",
    amount: "$75.50",
  },
  {
    date: "2024-10-25",
    order_id: "ORD123459",
    amount: "$320.00",
  },
  {
    date: "2024-10-24",
    order_id: "ORD123460",
    amount: "$500.00",
  },
  {
    date: "2024-10-23",
    order_id: "ORD123461",
    amount: "$120.00",
  },
  {
    date: "2024-10-22",
    order_id: "ORD123462",
    amount: "$250.75",
  },
  {
    date: "2024-10-21",
    order_id: "ORD123463",
    amount: "$175.00",
  },
  {
    date: "2024-10-20",
    order_id: "ORD123464",
    amount: "$90.00",
  },
  {
    date: "2024-10-19",
    order_id: "ORD123465",
    amount: "$300.00",
  },
];
</script>
